module.exports = __webpack_public_path__ + "media/src/assets/images/img-realestate-1-a4672a0b3f29fe1ced0036b9726941b7.png";